import React from 'react'
import Data from 'EurestoClass/Data'
import Constants from 'EurestoFonction/Constants'
import Grid from '@material-ui/core/Grid'

export default class extends React.Component {
  constructor (props) {
    super(props)
  }

  state = {}

  handleClickElAction = e => {
    const { table } = this.props

    e.preventDefault()
    !this.props.disabled && this.props.onContextMenu(e)
  }

  render () {
    const { table, groupe, selected } = this.props

    const categorie = Data.get(Constants.module.RESTAURANT, Constants.donnee.table_categorie, { id: table.categorie_id })

    const border = `1px ${this.props.action === 'regroupement' && groupe.categorie_id === table.categorie_id && 'dashed' || 'solid'} ${categorie.couleur || 'black'}`

    return <Grid container spacing={0} style={{
      margin: 0,
      padding: 0
    }} direction={'column'} justify={'center'}
                 alignItems={'center'}
                 alignContent={'center'}>
      {table.forme !== 2 && !table.verticale &&
      <Grid container spacing={0} style={{ margin: 0, padding: 0, height: 7.5 }} justify={'space-around'}
            alignItems={'center'}
            alignContent={'space-around'}>
        {
          Array(Math.round(table.couverts_max / 2)).fill(0).map(_ => <Grid item
                                                                           style={{
                                                                             padding: 0,
                                                                             margin: 0,
                                                                             height: 7.5,
                                                                             width: 25,
                                                                             background: 'transparent',
                                                                             borderTop: '2px solid black',
                                                                             borderRadius: '100%'
                                                                           }}/>)
        }
      </Grid>}
      <Grid container spacing={0} style={{ margin: 0, padding: 0 }} justify={'center'} alignItems={'center'}
            alignContent={'center'}>
        {table.forme !== 2 && table.verticale === 1 &&
        <Grid container spacing={0}
              style={{ margin: 0, padding: 0, width: 7.5, height: table.verticale && (25 * table.couverts_max) || 50 }}
              direction={'column'} justify={'space-around'}
              alignItems={'center'} alignContent={'space-around'}>
          {
            Array(Math.round(table.couverts_max / 2)).fill(0).map(_ => <Grid item
                                                                             style={{
                                                                               padding: 0,
                                                                               margin: 0,
                                                                               height: 25,
                                                                               width: 7.5,
                                                                               background: 'transparent',
                                                                               borderLeft: '2px solid black',
                                                                               borderRadius: '100%'
                                                                             }}/>)
          }
        </Grid>}
        <Grid container direction={'column'} justify={'center'} alignItems={'center'} alignContent={'center'}
              aria-owns={'action-menu-' + table.id}
              aria-haspopup="true"
              onContextMenu={this.handleClickElAction}
              className={`${this.props.disabled && 'cursor-not-allowed ' || this.props.className || 'cursor-grab '} anchorElement EurestoPrimary--text`}
              style={{
                margin: table.forme === 2 && '2.5px' || !table.verticale && '0px 2.5px' || '2.5px 0px',
                padding: 5,
                backgroundColor: selected && '#D9D9D9' || 'transparent',
                fontSize: 12,
                textAlign: 'center',
                verticalAlign: 'middle',
                display: 'inline-block',
                border: border,
                borderRadius: table.forme === 2 && '50%' || 2.5,
                width: table.forme === 2 && (40 + (table.couverts_max * 5)) || !table.verticale && (25 * table.couverts_max) || 50,
                height: table.forme === 2 && (40 + (table.couverts_max * 5)) || table.verticale && (25 * table.couverts_max) || 50,
              }}>
          <Grid item className={'anchorElement'}>
            <span style={{ fontWeight: 'bold' }} className={'EurestoPrimary--text anchorElement'}>
            {table.libelle}
            </span>
            <span className={'EurestoPrimary--text anchorElement'}>
              {table.couverts_min !== table.couverts_max && ('[' + table.couverts_min + '~' + table.couverts_max + ']') || ('[' + table.couverts_max + ']')}
            </span>
          </Grid>
        </Grid>
        {table.forme !== 2 && table.verticale === 1 &&
        <Grid container spacing={0}
              style={{ margin: 0, padding: 0, width: 7.5, height: table.verticale && (25 * table.couverts_max) || 50 }}
              direction={'column'} justify={'space-around'}
              alignItems={'center'} alignContent={'space-around'}>
          {
            Array(Math.trunc(table.couverts_max / 2)).fill(0).map(_ => <Grid item
                                                                             style={{
                                                                               padding: 0,
                                                                               margin: 0,
                                                                               height: 25,
                                                                               width: 7.5,
                                                                               background: 'transparent',
                                                                               borderRight: '2px solid black',
                                                                               borderRadius: '100%'
                                                                             }}/>)
          }
        </Grid>}
      </Grid>
      {table.forme !== 2 && !table.verticale &&
      <Grid container spacing={0} style={{ margin: 0, padding: 0, height: 7.5 }} justify={'space-around'}
            alignItems={'center'}
            alignContent={'space-around'}>
        {
          Array(Math.trunc(table.couverts_max / 2)).fill(0).map(_ => <Grid item
                                                                           style={{
                                                                             padding: 0,
                                                                             margin: 0,
                                                                             height: 7.5,
                                                                             width: 25,
                                                                             background: 'transparent',
                                                                             borderBottom: '2px solid black',
                                                                             borderRadius: '100%'
                                                                           }}/>)
        }
      </Grid>}
    </Grid>
  }

}



// WEBPACK FOOTER //
// ./app/Utilitaire/Component/Carcasse/Table/index.js